













import Vue from "vue";
import Component from "vue-class-component";
import UserMenu from "../menus/UserMenu.vue";
import ClockComponent from "./ClockComponent.vue";
import { targets } from "@/store";

@Component({
  components: {
    UserMenu,
    ClockComponent,
  },
})
export default class NavBarComponent extends Vue {
  targetsLoaded() {
    return targets.getters.targetsLoaded;
  }
}
